import React from 'react';

const LoadingOverlay = ({ show = true, message = null }) => {
  if (!show) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f8f9fa',
      zIndex: 9999
    }}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '16px'
      }}>
        {/* Elegant spinner */}
            <div style={{ 
          width: '48px', 
          height: '48px', 
          border: '3px solid #e9ecef', 
          borderTop: '3px solid #0066cc', 
              borderRadius: '50%', 
          animation: 'spin 0.8s linear infinite' 
            }}></div>
        
        {/* Optional message (subtle) */}
        {message && (
              <p style={{ 
            fontSize: '14px', 
            color: '#6c757d',
            margin: 0,
            fontWeight: 500
              }}>
                {message}
              </p>
        )}
      </div>
    </div>
  );
};

export default LoadingOverlay;
